export const TYPES = {
    READ_NEWS: 'READ_NEWS',
    CREATE_COMMENT : 'CREATE_COMMENT'
};